<div class="site-content px-6 py-6">

    <div class="container">


        <div class="content-confirmation text-center mt-5 mx-auto">
            <div>
        <img src="../../../../assets/images/checked-cin.svg"/>
        <h2 class="text-2xl" *ngIf="checkoutType">La tua prenotazione è avvenuta con successo.</h2>
        <p-divider />
        <p class="text-lg">Riceverai un'email di conferma non appena la cantina avrà accettato la tua richiesta. <br>
        Nel frattempo, ti abbiamo inviato un’email con tutte le informazioni relative alla tua prenotazione.</p>
        </div>
        <div class="my-8">
            <div>
            <a
            class="button-primary no-underline inline-block mt-3 pl-6 pr-6 font-bold"
            href="#"
            >Altre esperienze</a
          >
        </div>
    <div>
          <a
          class="button-secondary no-underline inline-block mt-3 pl-6 pr-6 font-bold"
          href="#"
          >Le tue prenotazioni</a
        >
        </div>
        </div>
        </div>
    </div>
</div>